import get from 'lodash/get';
import { emptyObj, getRequestData } from '@/utils';
import {
  qryIPInfoBsnl,
  setVasBsnl,
  manageSubsIPBsnl,
  qryAttrInfoBsnl,
} from '@/pages/ModifyBroadbandNetworkIP/services/modifyBroadbandNetworkIP';

export default {
  namespace: 'modifyBroadbandNetworkIP',
  state: {
    step: 0, // 变更网络IP业务流程的步骤
    searchCustInfo: {}, // 从搜索页面同步过来的用户信息
    serviceType: {}, // 从搜索页面同步过来的服务类型
    subServiceType: {}, // 从搜索页面同步过来的子服务类型
    ipList: [], // 当前IP列表
    ipMaxNum: 0, // 最大ip数
  },
  effects: {
    *qryIPInfoBsnl({ payload }, { call, put }) {
      const response = yield call(qryIPInfoBsnl, payload);
      const { ipDtoList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: { ipList: (ipDtoList || []).map(item => ({ ...item, selected: false })) },
        // payload: {
        //   ipList: [
        //     { ip: '123.23.312', selected: false },
        //     { ip: '122.23.233', selected: false },
        //     { ip: '122.23.211', selected: false },
        //     { ip: '123.232.312', selected: false },
        //   ],
        // },
      });
    },

    *setVasBsnl({ payload }, { call }) {
      const response = yield call(setVasBsnl, payload);
      return getRequestData(response);
    },

    *manageSubsIPBsnl({ payload }, { call }) {
      const response = yield call(manageSubsIPBsnl, payload);
      return getRequestData(response);
    },

    *qryIPMaxNum({ payload }, { call, put }) {
      const response = yield call(qryAttrInfoBsnl, payload);
      const { attrDtoList } = getRequestData(response);
      const ipMaxNum = get(attrDtoList, ['0', 'baseAttrDto', 'defaultValue']) || 12;
      yield put({
        type: 'save',
        payload: {
          ipMaxNum,
        },
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clear(state) {
      return emptyObj(state);
    },
  },
};
